import { useState } from 'react';

export default function useModal(initialValue) {
  const [opened, setOpened] = useState(!!initialValue);

  const open = () => setOpened(true);
  const close = () => setOpened(false);

  return { opened, setOpened, open, close };
}
